import React, { useContext, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'
import { useEffect } from 'react'
import { getEvaluacionProcedimiento } from '../../../API/Gerencia/Procedimientos/ProcedimientosRequets'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'
import { Button, Dialog } from 'primereact'
import Icon from '../../../Base/Components/Icon/Icon'
import EvaluacionListScreen from './Evaluaciones/EvaluacionListScreen'
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext'

const ProcedimientosListScreen = () => {

  const [listado, setListado] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [procedimientoSelect, setProcedimientoSelect] = useState(null)

  const { userAuth } = useContext(AuthContext);


  const getInfo = async () => {
    setLoading(true);
    const t = await getEvaluacionProcedimiento(2);
    setListado(t);
    setLoading(false);
  }

  const botones = (rowData) => {
    return <div>
      <Button className='p-button-rounded p-button-text' onClick={() => {
        setProcedimientoSelect(rowData);
        setShow(true);
      }}>
        <Icon icon={'ri-user-star-line'} />
      </Button>
    </div>
  }

  const Columns = [
    {
        field: 'idProcedimiento',
        header: 'idProcedimiento',
        headerEn: '',
        className: '',
        hide: userAuth.IdRol === 1
    },
    
    {
      header: 'Procedimiento',
      field: 'Procedimiento',
    },
    {
      header: 'Asunto',
      field: 'Asunto',
      className: 'XXXlarge'
    },
    {
      header: '',
      field: '',
      Format: 'Template',
      body: botones
    },

  ]

  const table = {
    Columns: Columns,
    Data: listado,
    loading: loading
  }

  const onHide = () => {
    setShow(false);
    setProcedimientoSelect(null);
  }

  useEffect(() => {
    getInfo()
  }, [])

  return (
    <div>
      <Dialog visible={show} onHide={onHide} style={{ width: '90vw', height: '80vh' }}
      header={<div><h3>{procedimientoSelect?.Procedimiento}</h3></div>}>
        <EvaluacionListScreen procedimientoSelect={procedimientoSelect} show={show} onHide={onHide} />
      </Dialog>
      <Card
        titulo={<div><h3>Procedimientos</h3></div>}
        contenido={<div style={{ height: '90vh' }} className='m-3'>
          <AgGrid table={table} />
        </div>}
      />
    </div>
  )
}

export default ProcedimientosListScreen